<template>
  <v-dialog
    :value="isOpen"
    max-width="400px"
    persistent
    no-click-animation
  >
    <v-card>
      <v-card-text class="pa-4 text-center title">
        {{ message }}
        <div class="loadingBouncer mx-auto mt-4">
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="loaderShadow"></div>
          <div class="loaderShadow"></div>
          <div class="loaderShadow"></div>
          <span></span>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'LoadingPlanDialog',
  props: {
    message: {
      type: String,
      default: 'Please wait while we build your plan'
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    }
  }
}
</script>